module.exports = __webpack_public_path__ + "static/media/calendar.d39b4ca8.svg";